import React, { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";

import Page from "../constants/pages";
import { useAppSelector } from "../store";

const ProtectedRoute: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { isAuthUser, lockScreen } = useAppSelector(store => ({
    isAuthUser: store.authUser.isAuthorization,
    lockScreen: store.LockScreen.lock,
  }));

  if (!isAuthUser) {
    return <Navigate to={Page.SIGN_IN} />;
  }

  if (lockScreen) {
    return <Navigate to={Page.LOCK_SCREEN} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
